import { useLanguageFromPath } from "plos/src/hooks/useLanguageFromPath";
import {
  fetchNewsByTagExpression,
  PulseContentItem,
} from "plos/src/utils/pulse";
import { useEffect, useState } from "react";
import NewsList from "../NewsList/NewsList";
import { NewsTagExpressionListProps } from "./types";

const NewsTagExpressionList = ({
  imgSizes,
  contentType = "TEXT",
  layout,
  limit,
  tagExpression,
  variant,
}: NewsTagExpressionListProps) => {
  const [items, setItems] = useState<PulseContentItem[]>([]);
  const lang = useLanguageFromPath();

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      try {
        const newsData = await fetchNewsByTagExpression(
          tagExpression,
          lang,
          contentType,
        );
        if (cancelled) return;
        setItems(newsData?.content || []);
      } catch (error) {
        if (cancelled) return;
        console.error("Failed to fetch news by tag expression:", error);
        setItems([]);
      }
    };
    fetchData();

    return () => {
      cancelled = true;
    };
  }, [tagExpression, contentType, lang]);

  if (!items.length) {
    return null;
  }

  return (
    <NewsList
      imgSizes={imgSizes}
      items={limit ? items.slice(0, limit) : items}
      layout={layout}
      variant={variant}
    />
  );
};

export default NewsTagExpressionList;
